<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">码库管理</div>
      <div class="top">
        <Button @click="inAddVal()">
          <Icon type="ios-add" size="50px" />
        </Button>
        <div class="select">
          <Input v-model="selectVal" search placeholder="输入企业名称或代码" />
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length==0"/>
        <Table border :columns="columns" :data="pageData" style="width: 100%" v-if="pageData.length!==0">
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #stat="{ row, index }">
            <span v-if="row.state == 0" style="color: red">未启用</span>
            <span v-if="row.state == 1" style="color: green">已启用</span>
            <span v-if="row.state == 2" style="color: blue">待生码</span>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">下载</Button>
            <!-- <Button type="error" @click="remove(index)">删除</Button> -->
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer title="修改企业资料" :closable="false" v-model="value">
        <p>企业代码</p>
        <p>企业名称</p>
        <p>正品回复语</p>
        <p>重复回复语</p>
        <p>多次回复语</p>
      </Drawer>
      <Drawer title="生码" :closable="false" v-model="addVal" width="600">
        <NewCode @close="newCodeClose"></NewCode>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewCode from "@/views/RowCode/NewCode";
import { GetCodeList, getBatchCodes, getBatchCodefiles } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "批号",
          key: "batch",
          width: 100,
        },
        {
          title: "企业代码",
          key: "clientcode",
          width: 100,
        },
        {
          title: "企业名称",
          key: "name",
          width: 250,
        },
        {
          title: "企业账号",
          key: "account",
          width: 200,
        },
        {
          title: "开始流水号",
          key: "startSerial",
          width: 200,
        },
        {
          title: "结束流水号",
          key: "endSerial",
          width: 200,
        },
        {
          title: "数量",
          key: "number",
          width: 150,
        },
        {
          title: "小标数量",
          key: "minTag",
          width: 150,
        },
        {
          title: "生码时间",
          key: "codeTime",
          width: 200,
        },
        {
          title: "前缀",
          key: "prefix",
          minWidth: 300,
          maxWidth: 500,
        },
        {
          title: "备注说明",
          key: "remark",
          width: 200,
        },
        {
          title: "状态",
          key: "state",
          width: 100,
          slot: "stat",
          fixed: "right",
        },
        {
          title: " ",
          slot: "action",
          width: 100,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      data: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
    };
  },
  mounted() {
    this.getCodeLists();

    // 初始列表过滤10
    this.pageData = this.data.filter((p, key) => {
      if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
        return p;
      }
    });

    this.allPage = this.data.length;
    // console.log(page);
  },
  components: {
    NewCode,
  },
  watch: {
    data(newVal, oldVal) {
      this.data = newVal;
    },

    // 搜索过滤
    selectVal(newVal, oldVal) {
      var data = this.data.filter((p) => {
        if (p.clientcode.indexOf(newVal) !== -1) {
          return p;
        }
        if (p.name.indexOf(newVal) !== -1) {
          return p;
        }
      });
      this.pages = 1;
      this.allPage = data.length;
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
  methods: {
    newCodeClose() {
      this.addVal = false
    },
    // // 删除按钮
    // remove(index){

    // },
    inAddVal(index) {
      this.addVal = true;
    },
    // 下载按钮
    show(index) {
      const batch = this.pageData[index].batch;
      getBatchCodes({
        batch
      }).then((res) => {
        const blob = new Blob([res]);//处理文档流
        const fileName = batch + '.txt';
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
    })
      // 通过批号获取生码数据
      // getBatchCodes({
      //   batch,
      // }).then((res) => {
      //   if (res.success) {
      //     // 下载文件
      //     window.open(res.data)
      //   } else {
      //     this.$Notice.error({ title: res.msg })
      //   }
      // });
      // this.value = true;
    },
    getCodeOne(filename, stat, num, l, code) {
      getBatchCodefiles({
        filename,
        stat,
        num,
        l,
        code,
      });
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      var data = this.data.filter((p) => {
        return p.name.indexOf(this.selectVal) !== -1;
      });
      // this.pages = 1
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
    getCodeLists() {
      GetCodeList({}).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        this.data = res;

        this.pageData = res.filter((p, key) => {
          if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
            return p;
          }
        });
        this.allPage = this.data.length;
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
